import React from 'react'
import './styles.scss'

interface Props {
  authors: string[]
  updated?: string|JSX.Element
}

export const MetaInfos = ({ authors, updated }: Props) => (
  <div className='ta metainfo'>
    <div className='ta author'>
      {authors.map((author, i) => {
        return (
          <React.Fragment key={i}>
            <span>{author}</span>
            {i < authors.length - 1 && <>, </>}
          </React.Fragment>
        )
      })}
    </div>
    {updated && <div className='ta updated'>{updated}</div>}
  </div>
)
